import { format } from 'date-fns';

export const formatInterviewDate = (jobDatetime: string) => {
  try {
    return format(new Date(jobDatetime), 'EEE, MMM d, yyyy');
  } catch {
    return jobDatetime;
  }
};

export const formatInterviewTime = (jobDatetime: string) => {
  try {
    return format(new Date(jobDatetime), 'h:mm a');
  } catch {
    return jobDatetime;
  }
};
